<template>
  <div>
    <Modal
      :title="modalTitle"
      :saving="isSaving"
      @hide-modal="$emit('hide-modal')"
      @submit="handleCreateAccountingCategory"
      @delete="handleDeleteAccountingCategory"
    >
      <template #delete>
        <div v-if="!isEditing"></div>
      </template>
      <TextField
        v-model="categoryName"
        label="Accounting Category Name"
        name="categoryName"
        :validation-errors="v$.$errors"
        class="full-width"
      />
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Modal from "../components/Modal.vue";
import TextField from "../components/TextField.vue";

export default {
  components: {
    TextField,
    Modal
  },
  props: {
    accountingCategory: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal", "save-success"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      categoryName: "",
      isSaving: false,
      isEditing: false
    };
  },
  validations() {
    return {
      categoryName: { required, $autoDirty: true }
    };
  },
  computed: {
    modalTitle() {
      return this.isEditing
        ? "Edit Accounting Category"
        : "Create Accounting Category";
    }
  },
  mounted() {
    if (this.accountingCategory && this.accountingCategory.id) {
      this.isEditing = true;
      this.categoryName = this.accountingCategory.name;
    }
  },
  methods: {
    ...mapActions([
      "createAccountingCategory",
      "updateAccountingCategory",
      "deleteAccountingCategory",
      "confirmDelete"
    ]),
    handleCreateAccountingCategory() {
      this.v$.$validate().then((valid) => {
        if (valid) {
          this.createAccountCategory();
        }
      });
    },
    createAccountCategory() {
      this.isSaving = true;
      const accountingAction = this.isEditing
        ? this.updateAccountingCategory
        : this.createAccountingCategory;
      const payload = {
        accounting_category: {
          ...this.accountingCategory,
          name: this.categoryName
        }
      };
      accountingAction(payload)
        .then(() => {
          this.closeModalWithSuccess();
        })
        .catch(() => {
          this.isSaving = false;
        });
    },
    closeModalWithSuccess() {
      const action = this.isEditing ? "edited" : "created";
      window.notify.success(
        `Accounting Category has been ${action} successfully!`
      );
      this.isSaving = false;
      this.$emit("save-success");
      this.$emit("hide-modal");
    },
    handleDeleteAccountingCategory() {
      this.confirmDelete().then(() => {
        this.deleteAccountingCategory(this.accountingCategory.id)
          .then(() => {
            window.notify.success("Accounting Category deleted successfully!");
            this.$emit("save-success");
          })
          .finally(() => {
            this.$emit("hide-modal");
          });
      });
    },
    toggleDeleteModal() {
      this.confirmDeleteModal = !this.confirmDeleteModal;
    }
  }
};
</script>

<style lang="scss" scoped></style>
